import React, { useState, useEffect } from "react";
import { INTERNET_CONNECTION_LOST } from "../../configurations/MessageConstants";

function NetworkDetector() {
  const [isDisconnected, setIsDisconnected] = useState(false);

  useEffect(() => {
    handleConnectionChange();
    window.addEventListener("online", handleConnectionChange);
    window.addEventListener("offline", handleConnectionChange);
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("online", handleConnectionChange);
      window.removeEventListener("offline", handleConnectionChange);
    };
  }, []);

  const handleConnectionChange = () => {
    const condition = navigator.onLine ? "online" : "offline";
    if (condition === "online") {
      const webPing = setInterval(() => {
        fetch("//google.com", {
          mode: "no-cors",
        })
          .then(() => {
            setIsDisconnected(false);
            return clearInterval(webPing);
          })
          .catch(() => setIsDisconnected(true));
      }, 2000);
      return;
    }
    return setIsDisconnected(true);
  };

  return (
    <div>
      {isDisconnected && (
        <div className="internet-error">
          <p>{INTERNET_CONNECTION_LOST}</p>
        </div>
      )}
    </div>
  );
}

export default NetworkDetector;
